'use strict';

module.exports = {
  'New York': '(646) 820-8070',
  'Boston': '(646) 820-8070',
  'Washington DC': '(646) 820-8070',
  'Chicago': '(646) 820-8070',
  'San Francisco': '(646) 820-8070',
  'Los Angeles': '(646) 820-8070'
};